import { trackEvent } from '../../../trackEvent/index'

let times = 0
let timer = null

function expose () {
  timer = setInterval(() => {
    times++
    trackEvent('userteam_ad_zj_loadpage_time_bt', { time: times * 3 })
  }, 3000)
}

function clearTimer () {
  clearInterval(timer)
  timer = null
}

export function initPageExposeTime () {
  expose()
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearTimer()
    } else {
      expose()
    }
  })
}
